import { render, staticRenderFns } from "./ProjectGoodNewsLetter.vue?vue&type=template&id=f84dfc46"
import script from "./ProjectGoodNewsLetter.vue?vue&type=script&lang=ts"
export * from "./ProjectGoodNewsLetter.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports